import { Box } from "@mui/material";
import {
  GRID_COLUMNS,
  GRID_GAP,
  ROW_HEIGHT,
} from "@pages:app/analytics/components/cards/DashboardCard";
import { ReactNode } from "react";

/**
 * Grid of cards on a fixed 12-column, fixed-row-height grid
 */
export const DashboardGrid = ({ children }: { children: ReactNode }) => (
  <Box
    sx={{
      marginY: "12px",
      display: "grid",
      gridTemplateColumns: {
        xs: "1fr",
        md: `repeat(${GRID_COLUMNS}, minmax(0, 1fr))`,
      },
      gridAutoRows: `${ROW_HEIGHT}px`,
      gridAutoFlow: "row dense",
      gap: `${GRID_GAP}px`,
    }}
  >
    {children}
  </Box>
);
